<template>
  <vx-card class="lg:p-8 w-full lg:w-9/12 fadeInLeft" v-if="!loading">
    <div v-if="isAuth">
      <div class="vx-card__title mb-6">
        <h4 class="mb-4" v-if="status === 'success'">Ваш E-mail подтвержден</h4>
        <h4 class="mb-4" v-else-if="status === 'verified'" >Ваш E-mail уже подтвержден, спасибо</h4>
        <h4 class="mb-4" v-else >Ваш E-mail НЕ подтвержден</h4>
        <p>Можете перейти на главную</p>
      </div>
      <a href="/">Перейти на главную</a>
    </div>
    <div v-else>
      <div class="vx-card__title mb-6">
        <h4 class="mb-4">Чтобы подтвердить E-mail необходимо быть авторизованным</h4>
        <p>Можете перейти к авторизации</p>
      </div>
      <vs-button :to="{name: 'login', query: {verify: verify_url}}">Авторизация</vs-button>
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Auth from '../../api/http/models/auth/Auth'

export default  {
  data () {
    return {
      loading: true,
      status: '',
      verify_url: this.$route.params.verify || ''
    }
  },
  computed: mapGetters(['isAuth']),
  async created () {
    const response = await Auth.verify(this.verify_url)
    if (response.status === 'success' || response.status === 'verified') {
      this.$vs.notify({
        color: 'success',
        title: 'Email подтвержден',
        text: ''
      })
    } else {
      this.$vs.notify({
        color: 'danger',
        title: 'Произошла ошибка',
        text: ''
      })
    }
    this.status = response.status
    this.loading = false
  }
}
</script>
